import { render, staticRenderFns } from "./wang-edit.vue?vue&type=template&id=38197880&scoped=true&"
import script from "./wang-edit.vue?vue&type=script&lang=js&"
export * from "./wang-edit.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./wang-edit.vue?vue&type=style&index=1&id=38197880&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38197880",
  null
  
)

export default component.exports